import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  useCallback,
} from "react";

import { useHistory, useParams } from "react-router-dom";
import { parseISO, format, isSameDay } from "date-fns";
import clsx from "clsx";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import { green, grey } from "@material-ui/core/colors";
import { i18n } from "../../translate/i18n";

import api from "../../services/api";
import ButtonWithSpinner from "../ButtonWithSpinner";
import MarkdownWrapper from "../MarkdownWrapper";
import { List, Tooltip } from "@material-ui/core";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import toastError from "../../errors/toastError";
import { v4 as uuidv4 } from "uuid";

import GroupIcon from "@material-ui/icons/Group";
import ContactTag from "../ContactTag";
import ConnectionIcon from "../ConnectionIcon";
import AcceptTicketWithouSelectQueue from "../AcceptTicketWithoutQueueModal";
import TransferTicketModalCustom from "../TransferTicketModalCustom";
import ShowTicketOpen from "../ShowTicketOpenModal";
import FinalizacaoVendaModal from "../FinalizacaoVendaModal";
import { isNil } from "lodash";
import { toast } from "react-toastify";
import { Done, HighlightOff, SwapHoriz, Add } from "@material-ui/icons";
import VisibilityIcon from "@material-ui/icons/Visibility"; // Ícone de spy
import useCompanySettings from "../../hooks/useSettings/companySettings";
import { emitLocalTicketTransition } from "../../utils/ticketTransition";
import NewTicketModal from "../NewTicketModal";
import {
  Avatar,
  Badge,
  ListItemAvatar,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  useMediaQuery,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  ticket: {
    position: "relative",
    minHeight: 72,
    paddingTop: 3,
    paddingBottom: 3,
    borderBottom: theme.mode === "light"
      ? "1px solid rgba(40, 100, 165, 0.18)"
      : "1px solid rgba(105, 165, 225, 0.20)",
    backgroundColor: theme.mode === "light" ? "#ffffff" : "#182231",
    transition: "background-color 140ms ease, box-shadow 140ms ease",
    "&:hover": {
      backgroundColor: theme.mode === "light" ? "#f5f9fd" : "#202d3e",
      boxShadow: theme.mode === "light"
        ? "inset 3px 0 0 rgba(40, 100, 165, 0.30)"
        : "inset 3px 0 0 rgba(105, 165, 225, 0.38)",
    },
    "&.Mui-selected, &.Mui-selected:hover": {
      backgroundColor: theme.mode === "light" ? "#eaf3fb" : "#24384d",
      boxShadow: theme.mode === "light"
        ? "inset 3px 0 0 #2b6ca3"
        : "inset 3px 0 0 #68a8de",
    },
    "& .MuiListItemText-root": {
      marginTop: 1,
      marginBottom: 1,
      minWidth: 0,
    },
    '@media (max-height: 850px), (max-width: 1440px)': {
      minHeight: 70,
      "& .MuiListItemText-root": {
        marginTop: 2,
        marginBottom: 2,
      },
    },
  },
  ticketChatbotActions: {
    paddingRight: 112,
  },
  ticketPendingActions: {
    paddingRight: 86,
  },
  ticketStandardActions: {
    paddingRight: 64,
  },
  ticketClosedActions: {
    paddingRight: 92,
  },

  compactAvatarWrapper: {
    marginLeft: -15,
    minWidth: 42,
    '@media (max-height: 850px), (max-width: 1440px)': {
      minWidth: 40,
    },
  },

  compactAvatar: {
    width: 36,
    height: 36,
    '@media (max-height: 850px), (max-width: 1440px)': {
      width: "34px !important",
      height: "34px !important",
    },
  },

  pendingTicket: {
    cursor: "unset",
  },
  queueTag: {
    background: "#FCFCFC",
    color: "#000",
    marginRight: 1,
    padding: 1,
    fontWeight: "bold",
    borderRadius: 3,
    fontSize: "0.5em",
    whiteSpace: "nowrap",
  },
  noTicketsDiv: {
    display: "flex",
    height: "100px",
    margin: 40,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  newMessagesCount: {
    justifySelf: "flex-end",
    textAlign: "right",
    position: "relative",
    top: 0,
    color: "green",
    fontWeight: "bold",
    marginRight: "10px",
    borderRadius: 0,
  },
  noTicketsText: {
    textAlign: "center",
    color: "rgb(104, 121, 146)",
    fontSize: "14px",
    lineHeight: "1.4",
  },
  metadataTag: {
    display: "inline-flex",
    alignItems: "center",
    flexShrink: 1,
    minWidth: 0,
    height: 15,
    maxWidth: 92,
    marginRight: 2,
    padding: "0 5px",
    borderRadius: 6,
    border: theme.mode === "light" ? "1px solid #dce3ec" : "1px solid #3a4657",
    backgroundColor: theme.mode === "light" ? "#f1f4f8" : "#263142",
    color: theme.mode === "light" ? "#5f6b7c" : "#b8c2d0",
    fontWeight: 600,
    fontSize: "0.52em",
    lineHeight: "15px",
    letterSpacing: "0.02em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  noTicketsTitle: {
    textAlign: "center",
    fontSize: "16px",
    fontWeight: "600",
    margin: "0px",
  },

  contactNameWrapper: {
    display: "flex",
    justifyContent: "space-between",
    marginLeft: "5px",
    fontWeight: "bold",
    color: theme.mode === "light" ? "black" : "white",
    minWidth: 0,
    overflow: "hidden",
  },

  lastMessageTime: {
    flexShrink: 0,
    marginLeft: 8,
    color: theme.mode === "light" ? "black" : grey[400],
    fontSize: 10,
    lineHeight: "14px",
  },

  lastMessageTimeUnread: {
    flexShrink: 0,
    marginLeft: 8,
    color: "green",
    fontWeight: "bold",
    fontSize: 10,
    lineHeight: "14px",
  },
  unreadCounter: {
    flexShrink: 0,
    minWidth: 18,
    height: 18,
    padding: "0 5px",
    marginLeft: 6,
    borderRadius: 9,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: green[500],
    color: "#ffffff",
    fontSize: 10,
    lineHeight: 1,
    fontWeight: 700,
    boxShadow: "0 2px 5px rgba(30, 135, 65, 0.24)",
  },

  closedBadge: {
    alignSelf: "center",
    justifySelf: "flex-end",
    marginRight: 32,
    marginLeft: "auto",
  },

  contactLastMessage: {
    paddingRight: "0%",
    marginLeft: "5px",
    color: theme.mode === "light" ? "black" : grey[400],
    lineHeight: 1.15,
    flex: 1,
    minWidth: 0,
  },

  contactLastMessageUnread: {
    paddingRight: 20,
    fontWeight: "bold",
    color: theme.mode === "light" ? "black" : grey[400],
    lineHeight: 1.15,
    flex: 1,
    minWidth: 0,
    // width: "50%",
  },

  badgeStyle: {
    color: "white",
    backgroundColor: green[500],
  },

  acceptButton: {
    position: "absolute",
    right: "1px",
  },
  ticketActions: {
    right: 4,
    top: "50%",
    transform: "translateY(-50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 0,
    maxWidth: "none",
    overflow: "visible",
    "& > span": {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: "auto",
      height: "auto",
      minHeight: 28,
      margin: 0,
      overflow: "visible",
      maxWidth: "none",
    },
    "& .MuiButtonBase-root": {
      position: "static !important",
      right: "auto !important",
      bottom: "auto !important",
      top: "auto !important",
      margin: 0,
    },
  },

  ticketQueueColor: {
    flex: "none",
    height: "100%",
    position: "absolute",
    top: "0%",
    left: "0%",
  },

  ticketInfo: {
    position: "relative",
    top: -13,
  },
  secondaryContentSecond: {
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap",
    flexDirection: "row",
    alignContent: "center",
    gap: 2,
    height: 16,
    marginTop: 1,
    overflow: "hidden",
    whiteSpace: "nowrap",
    maxWidth: "100%",
  },
  ticketTagsLine: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    height: 16,
    marginTop: 1,
    overflow: "hidden",
    whiteSpace: "nowrap",
    maxWidth: "100%",
  },
  reopenAction: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    minHeight: 32,
    overflow: "visible",
    whiteSpace: "nowrap",
  },
  ticketInfo1: {
    position: "relative",
    top: 13,
    right: 0,
  },
  Radiusdot: {
    "& .MuiBadge-badge": {
      borderRadius: 2,
      position: "inherit",
      height: 16,
      margin: 2,
      padding: 3,
    },
    "& .MuiBadge-anchorOriginTopRightRectangle": {
      transform: "scale(1) translate(0%, -40%)",
    },
  },
  connectionIcon: {
    marginRight: theme.spacing(1),
  },

  // Estilos para o modal da imagem
  imageModal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  imageModalContent: {
    outline: "none",
    maxWidth: "90vw",
    maxHeight: "90vh",
  },
  expandedImage: {
    width: "100%",
    height: "auto",
    maxWidth: "500px",
    borderRadius: theme.spacing(1),
  },
  clickableAvatar: {
    cursor: "pointer",
    "&:hover": {
      opacity: 0.8,
    },
  }
}));

const TicketListItemCustom = ({ setTabOpen, ticket, myAttendances }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width: 767px)");
  const history = useHistory();
  const handleReopenTicket = async (e) => {
    e.stopPropagation();
    if (!myAttendances) {
      try { await api.put(`/tickets/${ticket.id}`, { status: "open", userId: user.id }); } catch(err) {}
    }
    history.push(`/tickets/${ticket.uuid}`);
  };
  const [loading, setLoading] = useState(false);
  const [
    acceptTicketWithouSelectQueueOpen,
    setAcceptTicketWithouSelectQueueOpen,
  ] = useState(false);
  const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);

  const [openAlert, setOpenAlert] = useState(false);
  const [userTicketOpen, setUserTicketOpen] = useState("");
  const [queueTicketOpen, setQueueTicketOpen] = useState("");

  // Estados para o modal de finalização de venda
  const [openFinalizacaoVenda, setOpenFinalizacaoVenda] = useState(false);
  const [finalizacaoTipo, setFinalizacaoTipo] = useState(null);
  const [ticketDataToFinalize, setTicketDataToFinalize] = useState(null);
  const [showFinalizacaoOptions, setShowFinalizacaoOptions] = useState(false);

  const [imageModalOpen, setImageModalOpen] = useState(false); // Estado para o modal da imagem

  const { ticketId } = useParams();
  const isMounted = useRef(true);
  const { setCurrentTicket } = useContext(TicketsContext);
  const { user } = useContext(AuthContext);

  const { get: getSetting } = useCompanySettings();

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  // Função para abrir modal da imagem
  const handleImageClick = (e) => {
    e.stopPropagation(); // Prevenir que o clique no avatar selecione o ticket
    if (ticket?.contact?.urlPicture) {
      setImageModalOpen(true);
    }
  };

  // Função para fechar modal da imagem
  const handleImageModalClose = () => {
    setImageModalOpen(false);
  };

  const handleOpenAcceptTicketWithouSelectQueue = useCallback(() => {
    setAcceptTicketWithouSelectQueueOpen(true);
  }, []);

  const handleCloseTicket = async (e, id) => {
    e?.stopPropagation();
    // Verificar se a finalização com valor de venda está ativa
    if (
      user.finalizacaoComValorVendaAtiva === true ||
      user.finalizacaoComValorVendaAtiva === "true"
    ) {
      // Se estiver ativa, abrir o modal de finalização de venda
      setFinalizacaoTipo("comDespedida");
      setOpenFinalizacaoVenda(true);
      handleSelectTicket(ticket);
      history.push(`/tickets/${ticket.uuid}`);
    } else {
      if (!user?.id) {
        toast.error("Nao foi possivel identificar o atendente para fechar o ticket.");
        return;
      }

      setLoading(true);
      try {
        const setting = await getSetting({ column: "requiredTag" });

        if (setting.requiredTag === "enabled") {
          const contactTags = await api.get(
            `/contactTags/${ticket.contact.id}`
          );
          if (!contactTags.data.tags) {
            toast.warning(i18n.t("messagesList.header.buttons.requiredTag"));
            return;
          }
        }

        const { data: updatedTicket } = await api.put(`/tickets/${id}`, {
          status: "closed",
          // X apenas fecha: mantem carteira, kanban e follow-up.
          userId: user.id,
        });
        emitLocalTicketTransition(updatedTicket);
        history.push(`/tickets/`);
      } catch (err) {
        toastError(err);
      } finally {
        if (isMounted.current) setLoading(false);
      }
    }
  };

  const handleCloseIgnoreTicket = async (e, id) => {
    e?.stopPropagation();
    setLoading(true);
    try {
      const { data: updatedTicket } = await api.put(`/tickets/${id}`, {
        status: "closed",
        userId: user.id,
        sendFarewellMessage: false,
        amountUsedBotQueues: 0,
      });
      emitLocalTicketTransition(updatedTicket);
      history.push(`/tickets/`);
    } catch (err) {
      toastError(err);
    } finally {
      if (isMounted.current) setLoading(false);
    }
  };

  const truncate = (str, len) => {
    if (!isNil(str)) {
      if (str.length > len) {
        return str.substring(0, len) + "...";
      }
      return str;
    }
  };

  const handleCloseTransferTicketModal = useCallback(() => {
    if (isMounted.current) {
      setTransferTicketModalOpen(false);
    }
  }, []);

  const handleOpenTransferModal = () => {
    setLoading(true);
    setTransferTicketModalOpen(true);
    if (isMounted.current) {
      setLoading(false);
    }
    handleSelectTicket(ticket);
  };

  const handleStopFlowAndOpenTransfer = async (e) => {
    e.stopPropagation();
    try {
      await api.put(`/tickets/${ticket.id}`, {
        flowWebhook: false,
        isBot: false,
        useIntegration: false,
      });
    } catch (err) {
      // abre modal mesmo assim
    }
    setTransferTicketModalOpen(true);
    handleSelectTicket(ticket);
  };

  const handleOpenNewTicketModal = () => {
    setNewTicketModalOpen(true);
  };

  // Retomar conversa: reopen ticket (set status=open) then navigate

  const handleCloseNewTicketModal = (newTicket) => {
    setNewTicketModalOpen(false);
    if (newTicket) {
      // Se um novo ticket foi criado, redirecionar para ele
      handleSelectTicket(newTicket);
      history.push(`/tickets/${newTicket.uuid}`);
    }
  };

  const handleAcepptTicket = async (id) => {
    setLoading(true);
    try {
      const otherTicket = await api.put(`/tickets/${id}`, {
        status:
          ticket.isGroup && ticket.channel === "whatsapp" ? "group" : "open",
        userId: user?.id,
      });
      emitLocalTicketTransition(otherTicket.data);

      if (otherTicket.data.id !== ticket.id) {
        if (otherTicket.data.userId !== user?.id) {
          setOpenAlert(true);
          setUserTicketOpen(otherTicket.data.user.name);
          setQueueTicketOpen(otherTicket.data.queue.name);
        } else {
          setLoading(false);
          setTabOpen(otherTicket.data.isGroup ? "group" : "open");
          handleSelectTicket(otherTicket.data);
          history.push(`/tickets/${otherTicket.data.uuid}`);
        }
      } else {
        let setting;

        try {
          setting = await getSetting({
            column: "sendGreetingAccepted",
          });
        } catch (err) {
          toastError(err);
        }

        if (
          setting.sendGreetingAccepted === "enabled" &&
          (!ticket.isGroup || ticket.whatsapp?.groupAsTicket === "enabled")
        ) {
          handleSendMessage(ticket.id);
        }
        if (isMounted.current) {
          setLoading(false);
        }

        setTabOpen(otherTicket.data.isGroup ? "group" : "open");
        handleSelectTicket(otherTicket.data);
        history.push(`/tickets/${otherTicket.data.uuid}`);
      }
    } catch (err) {
      setLoading(false);
      toastError(err);
    }
  };

  const handleSendMessage = async (id) => {
    let setting;

    try {
      setting = await getSetting({
        column: "greetingAcceptedMessage",
      });
    } catch (err) {
      toastError(err);
    }
    if (!setting?.greetingAcceptedMessage) return;
    const msg = `${setting.greetingAcceptedMessage}`;
    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body: `${msg.trim()}`,
    };
    try {
      await api.post(`/messages/${id}`, message);
    } catch (err) {
      toastError(err);
    }
  };

  const handleCloseAlert = useCallback(() => {
    setOpenAlert(false);
    setLoading(false);
  }, []);

  const handleSelectTicket = (ticket) => {
    const code = uuidv4();
    const { id, uuid } = ticket;
    setCurrentTicket({ id, uuid, code });
  };

  const handleUpdateTicketStatusWithData = async (
    ticketData,
    sendFarewellMessage,
    finalizacaoMessage
  ) => {
    try {
      const { data: updatedTicket } = await api.put(`/tickets/${ticket.id}`, {
        ...ticketData,
        sendFarewellMessage,
        finalizacaoMessage,
      });
      emitLocalTicketTransition(updatedTicket);
      toast.success("Ticket finalizado com sucesso!");
      history.push(`/tickets/`);
    } catch (err) {
      toastError(err);
    }
  };

  // Função para espionar ticket chatbot
  const handleSpyTicket = () => {
    handleSelectTicket(ticket);
    history.push(`/tickets/${ticket.uuid}`);
  };

  // Lógica de permissão para mensagens pending - MOVIDA PARA DEPOIS DE TODAS AS FUNÇÕES
  const shouldBlurMessages = ticket.status === "pending" && user?.allowSeeMessagesInPendingTickets === "disabled";

  // Função para renderizar a mensagem com base na permissão - MOVIDA PARA DEPOIS DE TODAS AS FUNÇÕES
  const renderLastMessage = () => {
    if (shouldBlurMessages) {
      return (
        <MarkdownWrapper>
          {i18n.t("tickets.messageHidden") || "Mensagem oculta"}
        </MarkdownWrapper>
      );
    }

    if (!ticket.lastMessage) {
      return <br />;
    }

    if (ticket.lastMessage.includes("data:image/png;base64")) {
      if (ticket.lastMessage.includes("maps.google.com")) {
        return <MarkdownWrapper>📍 Localização</MarkdownWrapper>;
      }
      const adParts = ticket.lastMessage.split("|");
      const adUserText = adParts[adParts.length - 1]?.trim();
      if (adUserText && adUserText.length > 0) {
        return <MarkdownWrapper>{truncate(adUserText, 40)}</MarkdownWrapper>;
      }
      return <MarkdownWrapper>📢 Anúncio</MarkdownWrapper>;
    }

    if (ticket.lastMessage.includes("BEGIN:VCARD")) {
      return <MarkdownWrapper>Contato</MarkdownWrapper>;
    }

    return (
      <MarkdownWrapper>
        {truncate(ticket.lastMessage, 40)}
      </MarkdownWrapper>
    );
  };

  const compactMetadataTitle = [
    ticket.whatsapp?.name && `WhatsApp: ${ticket.whatsapp.name}`,
    `Fila: ${ticket.queue?.name || i18n.t("momentsUser.noqueue")}`,
    ticket.user?.name && `Atendente: ${ticket.user.name}`,
    ...(ticket.contact?.tags || []).map(tag => `Etiqueta: ${tag.name}`),
    ...(ticket.tags || []).map(tag => `Ticket: ${tag.name}`)
  ].filter(Boolean).join(" • ");
  const tagMetadataTitle = [
    ...(ticket.contact?.tags || []).map(tag => `Etiqueta: ${tag.name}`),
    ...(ticket.tags || []).map(tag => `Kanban/Tag: ${tag.name}`)
  ].filter(Boolean).join(" • ");

  return (
    <React.Fragment key={ticket.id}>
      {openAlert && (
        <ShowTicketOpen
          isOpen={openAlert}
          handleClose={handleCloseAlert}
          user={userTicketOpen}
          queue={queueTicketOpen}
        />
      )}
      {acceptTicketWithouSelectQueueOpen && (
        <AcceptTicketWithouSelectQueue
          modalOpen={acceptTicketWithouSelectQueueOpen}
          onClose={(e) => setAcceptTicketWithouSelectQueueOpen(false)}
          ticketId={ticket.id}
          ticket={ticket}
        />
      )}
      {transferTicketModalOpen && (
        <TransferTicketModalCustom
          modalOpen={transferTicketModalOpen}
          onClose={handleCloseTransferTicketModal}
          ticketid={ticket.id}
          ticket={ticket}
        />
      )}
      {newTicketModalOpen && (
        <NewTicketModal
          modalOpen={newTicketModalOpen}
          onClose={handleCloseNewTicketModal}
          initialContact={ticket.contact}
        />
      )}
      <ListItem
        button
        dense
        onClick={(e) => {
          console.log("e", e);
          const isCheckboxClicked =
            (e.target.tagName.toLowerCase() === "input" &&
              e.target.type === "checkbox") ||
            (e.target.tagName.toLowerCase() === "svg" &&
              e.target.type === undefined) ||
            (e.target.tagName.toLowerCase() === "path" &&
              e.target.type === undefined);

          if (isCheckboxClicked) return;

          handleSelectTicket(ticket);
        }}
        selected={ticketId && ticketId === ticket.uuid}
        className={clsx(classes.ticket, {
          [classes.pendingTicket]: ticket.status === "pending",
          [classes.ticketChatbotActions]: ticket.status === "chatbot",
          [classes.ticketPendingActions]: ticket.status === "pending",
          [classes.ticketStandardActions]: ticket.status === "open" || ticket.status === "group",
          [classes.ticketClosedActions]: ticket.status === "closed",
        })}
      >
        <ListItemAvatar className={classes.compactAvatarWrapper}>
          <Avatar
            className={clsx(classes.compactAvatar, classes.clickableAvatar)}
            style={{
              borderRadius: "50%",
              backgroundColor: !ticket?.contact?.urlPicture ? '#3f51b5' : undefined,
              color: '#fff',
              fontWeight: 'bold',
              fontSize: '18px',
            }}
            src={`${ticket?.contact?.urlPicture}`}
            onClick={handleImageClick}
          >
            {!ticket?.contact?.urlPicture && ticket?.contact?.name
              ? ticket.contact.name.trim().split(/\s+/).slice(0, 2).map(w => w[0]?.toUpperCase()).join('')
              : null}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          disableTypography
          primary={
            <span className={classes.contactNameWrapper}>
              <Typography
                noWrap
                component="span"
                variant="body2"
              >
                {ticket.isGroup && ticket.channel === "whatsapp" && (
                  <GroupIcon
                    fontSize="small"
                    style={{
                      color: grey[700],
                      marginBottom: "-1px",
                      marginLeft: "5px",
                    }}
                  />
                )}{" "}
                &nbsp;
                {ticket.channel && (
                  <ConnectionIcon
                    width="20"
                    height="20"
                    className={classes.connectionIcon}
                    connectionType={ticket.channel}
                  />
                )}{" "}
                &nbsp;
                {truncate(ticket.contact?.name, 60)}
              </Typography>
              {ticket.lastMessage && (
                <Typography
                  className={Number(ticket.unreadMessages) > 0
                    ? classes.lastMessageTimeUnread
                    : classes.lastMessageTime}
                  component="span"
                  variant="caption"
                >
                  {isSameDay(parseISO(ticket.updatedAt), new Date())
                    ? format(parseISO(ticket.updatedAt), "HH:mm")
                    : format(parseISO(ticket.updatedAt), "dd/MM/yyyy")}
                </Typography>
              )}
            </span>
          }
          secondary={
            <span className={classes.contactNameWrapper}>
              <Typography
                className={
                  Number(ticket.unreadMessages) > 0
                    ? classes.contactLastMessageUnread
                    : classes.contactLastMessage
                }
                noWrap
                component="span"
                variant="body2"
              >
                {renderLastMessage()}
                <Tooltip title={compactMetadataTitle || "Detalhes do atendimento"}>
                <span className={classes.secondaryContentSecond}>
                  {ticket?.whatsapp ? (
                    <span className={classes.metadataTag}>
                      {ticket.whatsapp?.name.toUpperCase()}
                    </span>
                  ) : (
                    <br></br>
                  )}
                  {
                    <span className={classes.metadataTag}>
                      {ticket.queueId
                        ? ticket.queue?.name.toUpperCase()
                        : ticket.status === "lgpd"
                        ? "LGPD"
                        : `${i18n.t("momentsUser.noqueue")}`}
                    </span>
                  }
                  {ticket?.user && (
                    <span className={classes.metadataTag}>
                      {ticket.user?.name.toUpperCase()}
                    </span>
                  )}
                </span>
                </Tooltip>
                {(ticket?.contact?.tags?.length > 0 || ticket?.tags?.length > 0) && (
                <Tooltip title={tagMetadataTitle}>
                <span className={classes.ticketTagsLine}>
                  {ticket?.contact?.tags?.map((tag) => {
                    return (
                      <ContactTag
                        tag={tag}
                        key={`ticket-contact-tag-${ticket.id}-${tag.id}`}
                      />
                    );
                  })}
                  {ticket.tags?.map((tag) => {
                    return (
                      <ContactTag
                        tag={tag}
                        key={`ticket-contact-tag-${ticket.id}-${tag.id}`}
                      />
                    );
                  })}
                </span>
                </Tooltip>
                )}
              </Typography>

              {Number(ticket.unreadMessages) > 0 && (
                <span className={classes.unreadCounter}>
                  {shouldBlurMessages ? "?" : ticket.unreadMessages}
                </span>
              )}
            </span>
          }
        />
        <ListItemSecondaryAction className={classes.ticketActions}>
          {/* Para tickets com status chatbot: aceitar, fechar e espiar */}
          {ticket.status === "chatbot" && (
            <>
              {/* Botao aceitar */}
              <span className={classes.secondaryContentSecond}>
                <ButtonWithSpinner
                  style={{
                    backgroundColor: "transparent",
                    boxShadow: "none",
                    border: "none",
                    color: theme.mode === "light" ? "green" : "#FFF",
                    padding: "0px",
                    borderRadius: "50%",
                    right: "76px",
                    fontSize: "0.6rem",
                    bottom: "-30px",
                    minWidth: "2em",
                    width: "auto",
                  }}
                  variant="contained"
                  className={classes.acceptButton}
                  size="small"
                  loading={loading}
                  onClick={(e) => {
                    e.stopPropagation();
                    ticket.queueId ? handleAcepptTicket(ticket.id) : handleOpenAcceptTicketWithouSelectQueue();
                  }}
                >
                  <Tooltip title="Aceitar conversa">
                    <Done />
                  </Tooltip>
                </ButtonWithSpinner>
              </span>
              {/* Botao fechar */}
              <span className={classes.secondaryContentSecond}>
                <ButtonWithSpinner
                  style={{
                    backgroundColor: "transparent",
                    boxShadow: "none",
                    border: "none",
                    color: theme.mode === "light" ? "red" : "#FFF",
                    padding: "0px",
                    borderRadius: "50%",
                    right: "51px",
                    fontSize: "0.6rem",
                    bottom: "-30px",
                    minWidth: "2em",
                    width: "auto",
                  }}
                  variant="contained"
                  className={classes.acceptButton}
                  size="small"
                  loading={loading}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCloseIgnoreTicket(e, ticket.id);
                  }}
                >
                  <Tooltip title="Fechar conversa">
                    <HighlightOff />
                  </Tooltip>
                </ButtonWithSpinner>
              </span>
              {/* Botao espiar */}
              <span className={classes.secondaryContentSecond}>
                <ButtonWithSpinner
                  style={{
                    backgroundColor: "transparent",
                    boxShadow: "none",
                    border: "none",
                    color: theme.mode === "light" ? "blue" : "#FFF",
                    padding: "0px",
                    borderRadius: "50%",
                    right: "26px",
                    fontSize: "0.6rem",
                    bottom: "-30px",
                    minWidth: "2em",
                    width: "auto",
                  }}
                  variant="contained"
                  className={classes.acceptButton}
                  size="small"
                  loading={loading}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSpyTicket();
                  }}
                >
                  <Tooltip title="Espiar conversa">
                    <VisibilityIcon />
                  </Tooltip>
                </ButtonWithSpinner>
              </span>
              {/* Botao transferir (para fluxo e abre modal) */}
              <span className={classes.secondaryContentSecond}>
                <ButtonWithSpinner
                  style={{
                    backgroundColor: "transparent",
                    boxShadow: "none",
                    border: "none",
                    color: theme.mode === "light" ? "#7B1FA2" : "#CE93D8",
                    padding: "0px",
                    borderRadius: "50%",
                    right: "1px",
                    fontSize: "0.6rem",
                    bottom: "-30px",
                    minWidth: "2em",
                    width: "auto",
                  }}
                  variant="contained"
                  className={classes.acceptButton}
                  size="small"
                  loading={loading}
                  onClick={handleStopFlowAndOpenTransfer}
                >
                  <Tooltip title="Transferir conversa">
                    <SwapHoriz />
                  </Tooltip>
                </ButtonWithSpinner>
              </span>
            </>
          )}

          {/* Para todos os outros status, manter os botões originais */}
          {ticket.status !== "chatbot" && (
            <>
              {ticket.status === "pending" && isMobile && (
                <ButtonWithSpinner
                  style={{
                    backgroundColor: "#6f3cc3",
                    color: "#fff",
                    borderRadius: "18px",
                    fontWeight: 600,
                    padding: "5px 14px",
                    fontSize: "0.75rem",
                    minWidth: "68px",
                    right: "1px",
                    bottom: "-30px",
                  }}
                  variant="contained"
                  className={classes.acceptButton}
                  size="small"
                  loading={loading}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSpyTicket();
                  }}
                >
                  Abrir
                </ButtonWithSpinner>
              )}
              <span className={classes.secondaryContentSecond}>
                {ticket.status === "pending" && !isMobile &&
                  (ticket.queueId === null || ticket.queueId === undefined) && (
                    <ButtonWithSpinner
                      style={{
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        border: "none",
                        color: theme.mode === "light" ? "green" : "#FFF",
                        padding: "0px",
                        borderRadius: "50%",
                        right: "51px",
                        fontSize: "0.6rem",
                        bottom: "-30px",
                        minWidth: "2em",
                        width: "auto",
                      }}
                      variant="contained"
                      className={classes.acceptButton}
                      size="small"
                      loading={loading}
                      onClick={(e) => handleOpenAcceptTicketWithouSelectQueue()}
                    >
                      <Tooltip title={`${i18n.t("ticketsList.buttons.accept")}`}>
                        <Done />
                      </Tooltip>
                    </ButtonWithSpinner>
                  )}
              </span>
              <span className={classes.secondaryContentSecond}>
                {ticket.status === "pending" && !isMobile && ticket.queueId !== null && (
                  <ButtonWithSpinner
                    style={{
                      backgroundColor: "transparent",
                      boxShadow: "none",
                      border: "none",
                      color: theme.mode === "light" ? "green" : "#FFF",
                      padding: "0px",
                      borderRadius: "50%",
                      right: "51px",
                      fontSize: "0.6rem",
                      bottom: "-30px",
                      minWidth: "2em",
                      width: "auto",
                    }}
                    variant="contained"
                    className={classes.acceptButton}
                    size="small"
                    loading={loading}
                    onClick={(e) => handleAcepptTicket(ticket.id)}
                  >
                    <Tooltip title={`${i18n.t("ticketsList.buttons.accept")}`}>
                      <Done />
                    </Tooltip>
                  </ButtonWithSpinner>
                )}
              </span>
              <span className={classes.secondaryContentSecond1}>
                {((ticket.status === "pending" && !isMobile) ||
                  ticket.status === "open" ||
                  ticket.status === "group") && (
                  <ButtonWithSpinner
                    style={{
                      backgroundColor: "transparent",
                      boxShadow: "none",
                      border: "none",
                      color: theme.mode === "light" ? "purple" : "#FFF",
                      padding: "0px",
                      borderRadius: "50%",
                      right: "26px",
                      position: "absolute",
                      fontSize: "0.6rem",
                      bottom: "-30px",
                      minWidth: "2em",
                      width: "auto",
                    }}
                    variant="contained"
                    className={classes.acceptButton}
                    size="small"
                    loading={loading}
                    onClick={handleOpenTransferModal}
                  >
                    <Tooltip title={`${i18n.t("ticketsList.buttons.transfer")}`}>
                      <SwapHoriz />
                    </Tooltip>
                  </ButtonWithSpinner>
                )}
              </span>
              <span className={classes.secondaryContentSecond}>
                {(ticket.status === "open" || ticket.status === "group") && (
                  <ButtonWithSpinner
                    style={{
                      backgroundColor: "transparent",
                      boxShadow: "none",
                      border: "none",
                      color: theme.mode === "light" ? "red" : "#FFF",
                      padding: "0px",
                      bottom: "0px",
                      borderRadius: "50%",
                      right: "1px",
                      fontSize: "0.6rem",
                      bottom: "-30px",
                      minWidth: "2em",
                      width: "auto",
                    }}
                    variant="contained"
                    className={classes.acceptButton}
                    size="small"
                    loading={loading}
                    onClick={(e) => handleCloseTicket(e, ticket.id)}
                  >
                    <Tooltip title={`${i18n.t("ticketsList.buttons.closed")}`}>
                      <HighlightOff />
                    </Tooltip>
                  </ButtonWithSpinner>
                )}
              </span>
              <span className={classes.secondaryContentSecond}>
                {((ticket.status === "pending" && !isMobile) || ticket.status === "lgpd") &&
                  (user.userClosePendingTicket === "enabled" ||
                    user.profile === "admin") && (
                    <ButtonWithSpinner
                      style={{
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        border: "none",
                        color: theme.mode === "light" ? "red" : "#FFF",
                        padding: "0px",
                        bottom: "0px",
                        borderRadius: "50%",
                        right: "1px",
                        fontSize: "0.6rem",
                        bottom: "-30px",
                        minWidth: "2em",
                        width: "auto",
                      }}
                      variant="contained"
                      className={classes.acceptButton}
                      size="small"
                      loading={loading}
                      onClick={(e) => handleCloseIgnoreTicket(e, ticket.id)}
                    >
                      <Tooltip title={`${i18n.t("ticketsList.buttons.ignore")}`}>
                        <HighlightOff />
                      </Tooltip>
                    </ButtonWithSpinner>
                  )}
              </span>
              <span className={classes.reopenAction}>
                {/* Fechado pelo X abre pelo proprio card;
                    Retomar fica reservado ao atendimento realmente resolvido. */}
                {ticket.status === "closed" && isNil(ticket.userId) && (
                  <ButtonWithSpinner
                    style={{
                      backgroundColor: "#D4AF37",
                      color: "#fff",
                      borderRadius: 20,
                      fontWeight: 600,
                      padding: "4px 12px",
                      fontSize: "0.75rem",
                      minWidth: 72,
                      width: "auto",
                    }}
                    variant="contained"
                    size="small"
                    loading={loading}
                    onClick={handleReopenTicket}
                  >
                    Retomar
                  </ButtonWithSpinner>
                )}
              </span>
            </>
          )}
        </ListItemSecondaryAction>
      </ListItem>

      {/* Modal de Finalização de Venda */}
      {openFinalizacaoVenda && (
        <FinalizacaoVendaModal
          open={openFinalizacaoVenda}
          onClose={() => setOpenFinalizacaoVenda(false)}
          ticket={ticket}
          onFinalizar={(ticketData) => {
            setOpenFinalizacaoVenda(false);
            setTicketDataToFinalize(ticketData);
            setShowFinalizacaoOptions(true);
          }}
        />
      )}

      {/* Modal de Opções de Finalização */}
      {showFinalizacaoOptions && (
        <Dialog
          open={showFinalizacaoOptions}
          onClose={() => setShowFinalizacaoOptions(false)}
          aria-labelledby="finalizacao-options-title"
        >
          <DialogTitle id="finalizacao-options-title">
            Como deseja finalizar?
          </DialogTitle>
          <DialogActions>
            <Button
              onClick={async () => {
                setShowFinalizacaoOptions(false);
                await handleUpdateTicketStatusWithData(
                  ticketDataToFinalize,
                  false,
                  null
                );
              }}
              style={{ background: theme.palette.primary.main, color: "white" }}
            >
              {i18n.t("messagesList.header.dialogRatingWithoutFarewellMsg")}
            </Button>
            <Button
              onClick={async () => {
                setShowFinalizacaoOptions(false);
                await handleUpdateTicketStatusWithData(
                  ticketDataToFinalize,
                  true,
                  null
                );
              }}
              style={{ background: theme.palette.primary.main, color: "white" }}
            >
              {i18n.t("messagesList.header.dialogRatingCancel")}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Modal da Imagem */}
      <Dialog
        open={imageModalOpen}
        onClose={handleImageModalClose}
        className={classes.imageModal}
        maxWidth="md"
        fullWidth
      >
        <DialogContent className={classes.imageModalContent}>
          <img
            src={ticket?.contact?.urlPicture}
            alt={ticket?.contact?.name || "Foto do contato"}
            className={classes.expandedImage}
          />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default TicketListItemCustom;
